// extracted by mini-css-extract-plugin
export default {"root":"PageHero_root__Jiswp"};